import { createContext } from 'react';

export interface ISelectedNode {
  name: string | null;
}

interface ContextType {
  selectedNode: ISelectedNode | undefined;
  setSelectedNode: (selectedNode: ISelectedNode | undefined) => void;
}

const defaultValue: ContextType = {
  selectedNode: undefined,
  setSelectedNode: () => {},
};

export const SelectedNodeContext = createContext<ContextType>(defaultValue);
